import React, { memo, useState, useCallback } from 'react'
import { Button } from '@material-ui/core'
import Dialog from '../../components/Dialog'
import * as Styled from './styled'

const FaqDetailModal = ({ open, onCancel, isDesk, data }) => {

  // const [isAnswered, setIsAnswered] = useState(false);
  // const [selectedAnswer, setSelectedAnswer] = useState({ yes: false, no: false })

  // const handleAnserClick = useCallback(answer => {
  //   setIsAnswered(true);
  //   setSelectedAnswer({ yes: answer === 'sim', no: answer === 'não' });
  // }, [setIsAnswered, setSelectedAnswer])

  return (
    <Dialog
      width={632}
      title={
        <>
          <Styled.Title>{data.subject}</Styled.Title>
          <Styled.SubTitle>{data.text}</Styled.SubTitle>
        </>
      }
      onClose={onCancel}
      open={open}
      isDesk={isDesk}
    >

      <Styled.Content>
        {data.answer}
      </Styled.Content>

      {/* <Styled.Footer>
        <Styled.Ask>Essa resposta foi útil?</Styled.Ask>
        <Button className={selectedAnswer.yes ? 'selected' : undefined} variant="outlined" onClick={() => { handleAnserClick('sim') }}>Sim</Button>
        {' '}<Button className={selectedAnswer.no ? 'selected' : undefined} onClick={() => { handleAnserClick('não') }} variant="outlined">Não</Button>
        {isAnswered && <Styled.AskCongrats>Obrigado por avaliar!</Styled.AskCongrats>}
      </Styled.Footer> */}

    </Dialog>
  )
}


FaqDetailModal.defaultProps = {
  data: {
    answer: '',
    subject: '',
    text: ''
  }
}

export default memo(FaqDetailModal)
